import { css } from 'styled-system/css';

export const balancePanelStyle = {
	balancePanel: css({
		display: 'flex',
		flexDir: 'column',
		p: '12px',
		gap: '6px',
		boxShadow: '0 3px 9px rgba(0, 0, 0, .25)',
		borderRadius: '6px',
		bgColor: 'jupiter.grey.10',
		color: 'jupiter.grey.90',
		fontWeight: '400',
		fontSize: '12px',
		md: {
			w: '282px',
		},
		_mdBelow: {
			width: '100%',
			borderRadius: '0 0 6px 6px',
		},
		'& .btn': {
			width: '100%',
		},
	}),
	divider: css({
		w: '100%',
		h: '1px',
		bgColor: 'jupiter.grey.divider',
	}),
	button: css({
		minHeight: '30px!',
	}),
	switch: css({
		display: 'flex',
		alignSelf: 'flex-end',
		gap: '6px',

		md: {
			display: 'none'
		}
	}),
	switchText: css({
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		fontSize: '14px',
		fontStyle: 'normal',
		fontWeight: 400,
		lineHeight: '18px',
	}),
	switchBtn: css({
		flex: 'none',
		backgroundColor: 'black.3',
		borderRadius: '30px',
		display: 'flex',
		width: '40px',
		height: '20px',
		padding: '2px',
		alignItems: 'center',
		transition: 'background-color .3s',
		'&[data-active=true]': {
			backgroundColor: 'brand.500',
		}
	}),
	switchDot: css({
		display: 'inline-block',
		backgroundColor: 'white',
		borderRadius: '100em',
		width: '16px',
		height: '16px',
		position: 'relative',
		left: 0,
		transition: 'left .3s',
		'[data-active=true] >&': {
			left: 'calc(100% - 16px)',
		}
	}),
	panel: css({
		display: 'flex',
		flexDir: 'column',
		gap: '6px',
		bgColor: 'jupiter.grey.20',
		p: '6px',
		borderRadius: '6px',
	}),
	title: css({
		fontWeight: '700',
		textAlign: 'left',
		fontSize: '14px',
	}),
	group: css({
		display: 'flex',
		flexDir: 'column',
		gap: '6px',
	}),
	row: css({
		display: 'flex',
		justifyContent: 'space-between',
	}),
	label: css({
		fontWeight: '500',
		fontSize: '13px',
	}),
	amount: css({
		display: 'flex',
		alignItems: 'center',
		fontWeight: '700',
		color: 'jupiter.main.primary',
		fontSize: '13px',
		'& img': {
			mr: '3px',
		}
	}),
	time: css({
		display: 'flex',
		flexDir: 'column',
		gap: '6px',
		color: 'jupiter.grey.60',
	}),
}